export default {
  BASE_URL: '',
  api: [
    {
      name: 'getAddress',
      method: 'GET',
      desc: '获取地址列表',
      path: '//contacts/getAddress'
    },
    {
      name: 'addAddress',
      method: 'POST',
      desc: '新增编辑',
      path: '//contacts/addAddress'
    },
    {
      name: 'delAddress',
      method: 'DELETE',
      desc: '删除地址',
      path: '//contacts/delAddress'
    },
    {
      name: 'updateIsDefault',
      method: 'PUT',
      desc: '设置默认地址',
      path: '//contacts/updateIsDefault'
    },
    {
      name: 'projectList',
      method: 'GET',
      desc: '获取项目列表',
      path: '/bid/projectList'
    },
    {
      name: 'addProj',
      method: 'POST',
      desc: '新增项目',
      path: '//crmProject/addProj'
    },
    {
      name: 'checkProjName',
      method: 'GET',
      desc: '检测项目名称是否存在',
      path: '//crmProject/checkProjName'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/me-center/address.js